import "./CultivosPage.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { CultivoResponse } from "../../../shared/response/comun/CultivoResponse";
import { CultivoListService } from "../../../shared/services/catalogos/CultivoListService";

function monitoreoLabel(c: CultivoResponse): string {
  if (c.isSinMonitoreo)          return "Sin monitoreo";
  if (c.isMonitoreoCafe)         return "Café";
  if (c.isMonitoreoCitricos)     return "Cítricos";
  if (c.isMonitoreoAguacateHass) return "Aguacate Hass";
  if (c.isMonitoreoMango)        return "Mango";
  if (c.isMonitoreoMacadamia)    return "Macadamia";
  if (c.isMonitoreoGuanabana)    return "Guanábana";
  return "—";
}

export class CultivosPage extends BasePageComponent {
  private _all:      CultivoResponse[] = [];
  private _filtered: CultivoResponse[] = [];

  public getAppRoute(): string { return "/admin/catalogos/cultivos"; }
  public getPageTitle(): string | null { return "Cultivos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page cult-page";

    pageContent.innerHTML = `
      <div class="cult-content">

        <div class="cult-pg-hd">
          <div>
            <div class="cult-pg-ey">Catálogo</div>
            <div class="cult-pg-t">Cultivos</div>
            <div class="cult-pg-s">Tipos de cultivo y su configuración de monitoreo</div>
          </div>
        </div>

        <div class="cult-toolbar">
          <div class="cult-search-wrap">
            <span class="cult-search-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input class="cult-si" id="cult-search" type="text" placeholder="Buscar por nombre…">
          </div>
          <span class="cult-count" id="cult-count"></span>
        </div>

        <div class="cult-tbl-wrap">
          <table class="cult-tbl">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Tipo de monitoreo</th>
              </tr>
            </thead>
            <tbody id="cult-tbody"></tbody>
          </table>
        </div>

      </div>
    `;

    this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    const tbody = document.getElementById("cult-tbody");
    if (tbody) tbody.innerHTML = `<tr><td colspan="2" class="cult-empty">Cargando…</td></tr>`;

    this._all = await CultivoListService.instance.get().catch(() => []);
    this._filtered = [...this._all];

    this._render();
    document.getElementById("cult-search")?.addEventListener("input", () => this._applyFilter());
  }

  private _applyFilter(): void {
    const q = ((document.getElementById("cult-search") as HTMLInputElement | null)?.value ?? "").toLowerCase().trim();
    this._filtered = q
      ? this._all.filter((c) => c.nombre.toLowerCase().includes(q))
      : [...this._all];
    this._render();
  }

  private _render(): void {
    const tbody = document.getElementById("cult-tbody");
    const count = document.getElementById("cult-count");
    if (!tbody) return;

    if (count) {
      count.textContent = `${this._filtered.length} cultivo${this._filtered.length !== 1 ? "s" : ""}`;
    }

    if (this._filtered.length === 0) {
      tbody.innerHTML = `<tr><td colspan="2"><div class="cult-empty">Sin resultados</div></td></tr>`;
      return;
    }

    const label = monitoreoLabel;
    tbody.innerHTML = this._filtered
      .map((c) => {
        const mon = label(c);
        const hasMon = !c.isSinMonitoreo && mon !== "—";
        return `<tr>
          <td class="cult-cell-name">${this._esc(c.nombre)}</td>
          <td><span class="cult-badge ${hasMon ? "cult-badge-mon" : "cult-badge-none"}">${this._esc(mon)}</span></td>
        </tr>`;
      })
      .join("");
  }

  private _esc(s: string): string {
    return (s ?? "—").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
